import { UuidIdGenerator } from '../../../common'
import { MunicipalEntity } from './municipalEntities'
import { faker } from '@faker-js/faker/locale/ru'

export function mockMunicipalEntity(opts?: Partial<MunicipalEntity>): MunicipalEntity {
  const idGenerator = new UuidIdGenerator()
  return {
    id: idGenerator.generate(),
    name: faker.location.state(),
    index: faker.number.int({ max: 1000000 }),
    createdAt: new Date(),
    kladrCode: '61' + faker.string.numeric({ length: 3, allowLeadingZeros: false }),
    ...opts,
  }
}
